import { useLocation } from 'react-router-dom';

export function useQuery() {
	return new URLSearchParams(useLocation().search);
}

/**
 * Update current url with query string params.
 * @param {object|false} If false, returns url with no params
 * If value is empty string, than qs param will be removed
 * @returns {string} url
 */
export function urlWithParams(params = {}) {
	let currentUrlParams = new URLSearchParams(false === params ? '' : window.location.search);

	Object.keys(params).map((key) => {
		const value = String(params[key]);
		if (value.length > 0) {
			currentUrlParams.set(key, params[key]);
		} else {
			currentUrlParams.delete(key);
		}
		return true;
	});

	return `${window.location.pathname}?${currentUrlParams.toString()}`;
}

export function capitalize(s) {
	if (typeof s !== 'string') return '';
	return s.charAt(0).toUpperCase() + s.slice(1);
}

export function wrapIframes(str) {
	if (!str || 0 === str.length) {
		return str;
	}
	const rew = /width=["']{1}(\d+)["']{1}/gm;
	const mw = rew.exec(str);
	const w = mw && mw[1] ? parseInt(mw[1]) : 0;

	const reh = /height=["']{1}(\d+)["']{1}/gm;
	const mh = reh.exec(str);
	const h = mh && mh[1] ? parseInt(mh[1]) : 0;

	const pt = w > 0 && h > 0 ? `padding-top: ${Math.round((h / w) * 100)}%;` : '';
	return (
		str
			.replace('<iframe', `<span class="slp-iframe-wrapper" ${pt}><iframe`)
			.replace('</iframe>', '</iframe></span>')
			.replace('controls ', 'controls controlsList="nodownload"')
			// .replace('controls ', '')
			.replace('controls="controls"', 'controls="controls" controlsList="nodownload"')
		// .replace('controls="controls"', '')
	);
}

export function currentDomain() {
	const url = window.location.href;
	const arr = url.split('/');
	return arr[0] + '//' + arr[2];
}
